module.exports = __webpack_public_path__ + "img/1532947838.282e250a.jpg";